import { NotificationCreate } from './NotificationCreate'
import NotificationList from './NotificationList'
import { NotificationEdit } from "./NotificationEdit";
import NotificationDetail from './NotificationDetail';
import { SMSCreate } from './SMSCreate';
import { PopupNotificationCreate } from './PopupNotificationCreate'
import PopupNotificationList from './PopupNotificationList';
import { PopupNotificationEdit } from './PopupNotificationEdit';
import { COUNTRY_TH } from 'util/constants';
import * as urls from './urls'
import * as utils from './utils'

export const NotificationResources = [
  {
    "name": utils.SMSSendingResourceName,
    "frontendPath": urls.smsCreateFrontendPath,
    "backendPath": urls.smsCreateBackendPath,
    "list": SMSCreate,
    "showInSideMenu": true,
  },
  {
    "name": utils.NotificationResourceName,
    "frontendPath": urls.notificationFrontendPath,
    "backendPath": urls.notificationBackendPath,
    "list": NotificationList,
    "create": NotificationCreate,
    "edit": NotificationEdit,
    "show": NotificationDetail,
    "showInSideMenu": true,
  },
  {
    "name": utils.PopupNotificationResourceName,
    "frontendPath": urls.popupNotificationFrontendPath,
    "backendPath": urls.popupNotificationBackendPath,
    "list": PopupNotificationList,
    "create": PopupNotificationCreate,
    "edit": PopupNotificationEdit,
    "showInSideMenu": process.env.REACT_APP_COUNTRY === COUNTRY_TH,
  }
];

export const NotificationCustomRoutes = [

];



// WEBPACK FOOTER //
// ./src/routes/notification/resources.js